/**
 * @generated SignedSource<<30c1fae06123bcc34001ee67dd48b64a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveQuoteRuleMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type productSidePanelContent_RemoveQuoteRuleMutation$data = {
  readonly removeProductsFromQuoteRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemoveQuoteRuleMutation = {
  response: productSidePanelContent_RemoveQuoteRuleMutation$data;
  variables: productSidePanelContent_RemoveQuoteRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromQuoteRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveQuoteRuleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveQuoteRuleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b60fb2b1b0f16a747b16c1ce74d9c705",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveQuoteRuleMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveQuoteRuleMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromQuoteRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "7c7cdb09b860d36a5eac80702a4e112d";

export default node;
